import React, { useState } from "react";
import flag_2 from "./../assets/img/tarh-parcham-iran-psdtarh2.png";
import { ApiEndpoints, useApiCall } from "../api";
import MainLayout from "../layout/main";
import Loading from "../component/loading";
import { storageApi } from "../storage/storageApi";
import { SelectOption } from "../component/selectOption";
import { Input } from "../component/input";
import { IoInformationCircleSharp } from "react-icons/io5";
import { Tooltip } from "../component/Tooltip";
import { useValidation, ValidationTypes } from "../helper/validation";
import { useAlert } from "react-alert";
import { useAppNavigation } from "../router/routes";

const ProfilePage = () => {
  const { navigate, queryParameter, params } = useAppNavigation();
  const alert = useAlert();
  const loginUser = storageApi.useLogin();
  const user = storageApi.useGetUser();
  const [phoneNumber] = useState(user.phoneNumber);

  const [fullName, setFullName] = useState(user.fullName);
  const [landlineNumber, setLandlineNumber] = useState(user.landlineNumber);
  const [sectionType, setSectionType] = useState(user.sectionType);
  const [structureType, setStructureType] = useState(user.structureType);
  const [assistance, setAssistance] = useState(user.assistance);
  const [state, setState] = useState(user.state);
  console.log("userData", user);
  const [city, setCity] = useState(user.city);
  const [department, setDepartment] = useState(user.department);
  const [organization, setOrganization] = useState(user.organization);

  const { errors, validate, removeError } = useValidation([
    {
      name: "state",
      label: "استان",
      value: state,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
      ],
    },
    {
      name: "city",
      label: "شهر",
      value: city,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
      ],
    },
    {
      name: "organization",
      label: "سازمان",
      value: organization,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
      ],
    },
    {
      name: "landlineNumber",
      label: "شماره تماس",
      value: landlineNumber,
      validations: [
        {
          type:
            structureType === "setadi_markazi"
              ? ValidationTypes.onlyStartsWith021
              : ValidationTypes.onlyStartsWithout09,
        },
      ],
    },
  ]);

  const isAdmin = () => {
    return user.role == "state_manager";
  };
  const [
    [cityList, stateList, organizationList, departmentList],
    { loading: signupFormLoading, fetch: fetchSignupForm },
  ] = useApiCall({
    endpoints: [
      ApiEndpoints.user.cityList,
      ApiEndpoints.user.stateList,
      ApiEndpoints.user.organizationList,
      ApiEndpoints.user.departmentList,
    ],
  });
  const [, { loading: updateProfileLoading, fetch: updateProfile }] =
    useApiCall({
      endpoints: [ApiEndpoints.user.updateProfile],
      payload: {
        phoneNumber,
        landlineNumber,
        fullName,
        sectionType,
        structureType,
        assistance,
        state,
        city,
        department,
        organization,
        userId: user.id,
      },
      lazy: true,
    });

  const sectionList = [
    {
      id: "keshvari",
      title: "کشوری",
    },
    {
      id: "lashkari",
      title: "لشکری",
    },
  ];
  const structureList = [
    {
      id: "setadi_markazi",
      title: "ستادی/مرکزی",
    },
    {
      id: "ostani",
      title: "استانی",
    },
  ];

  const [, { fetch: fetchProfile, loading: profileLoading }] = useApiCall({
    endpoints: ApiEndpoints.user.profile,
    lazy: true,
  });

  const submitForm = async () => {
    const { isValid } = validate();

    if (!isValid) {
      return alert.error("لطفا خطا های فرم را برطرف کنید");
    }
    const [signupResult] = await updateProfile();
    if (signupResult.isOk) {
      const [profile] = await fetchProfile();
      if (profile.isOk) {
        await loginUser({
          ...user,
          ...profile.data,
        });
        alert.success("بروزرسانی موفق");
        return navigate("/dashboard");
      }
    }
  };

  const tooltip =
    "راهنما : در صورت استقرار در دستگاه مرکزی ( وزارتخانه/ سازمان مرکزی ( مستقر در تهران)) که در ساختار، استانی محسوب نمی شوید باید ستادی/مرکزی را انتخاب نمایید.";
  const [showPopup, setShowPopup] = useState(false);

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        {/* sec1 */}
        <div className="sec1 w-full bg-greenblue-light h-auto md:rounded-3xl rounded-xl relative p-8 md:min-h-[180px] min-h-[100px]">
          <img src={flag_2} className=" absolute left-0 top-0 md:h-42 h-24" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] h-full mx-auto">
            <div className="md:text-3xl text-xl text-center font-bold">
              <span className=" text-greenblue"> حساب کاربری </span>
            </div>
            {/* form search list */}
          </div>
        </div>

        {/* list  */}
        <div className="md:p-8 p-4 md:w-[70%] w-full mx-auto bg-white rounded-xl border-2 border-gray-200">
          <div className="grid md:grid-cols-2 grid-cols-1 md:gap-4 gap-6 w-full">
            <div className="form-field w-full relative mt-2">
              <SelectOption
                label={"نوع دستگاه"}
                value={sectionType}
                options={sectionList.map((c) => ({
                  label: c.title,
                  value: c.id,
                }))}
                onChange={(e) => setSectionType(e.value)}
              />
            </div>
            <div className="form-field w-full relative mt-2">
              <SelectOption
                disabled={isAdmin()}
                label={"ساختار دستگاه تابعه"}
                labelComponent={<Tooltip tooltip={tooltip} />}
                value={structureType}
                options={structureList.map((c) => ({
                  label: c.title,
                  value: c.id,
                }))}
                onChange={(e) => setStructureType(e.value)}
              />
            </div>

            {structureType === "ostani" && (
              <div className="form-field w-full relative mt-2">
                <SelectOption
                  disabled={isAdmin()}
                  label={"استان"}
                  value={state}
                  options={stateList?.data?.map((c) => ({
                    label: c.name,
                    value: c.id,
                  }))}
                  onChange={(e) => {
                    setState(e.value);
                    setCity(null);
                    removeError("state");
                  }}
                />
                {errors["state"] && (
                  <p className={"text-sm mt-2 text-red-600"}>
                    {errors["state"]}
                  </p>
                )}
              </div>
            )}

            {structureType === "ostani" && (
              <div className="form-field w-full relative mt-2">
                <SelectOption
                  label={"شهر"}
                  value={city}
                  options={cityList?.data
                    ?.filter((c) => c.state === state)
                    ?.map((c) => ({
                      label: c.name,
                      value: c.id,
                    }))}
                  onChange={(e) => {
                    setCity(e.value);
                    removeError("city");
                  }}
                />
                {errors["city"] && (
                  <p className={"text-sm mt-2 text-red-600"}>
                    {errors["city"]}
                  </p>
                )}
              </div>
            )}

            <div className="form-field w-full relative mt-2">
              <SelectOption
                label={"نام مجموعه"}
                value={department}
                options={departmentList?.data
                  ?.filter((c) => c.dastgah_type === sectionType)
                  ?.map((c) => ({
                    label: c.title,
                    value: c.id,
                  }))}
                onChange={(e) => {
                  setDepartment(e.value);
                  setOrganization(null);
                }}
              />
            </div>
            <div className="form-field w-full relative mt-2">
              <SelectOption
                label={"نام سازمان"}
                value={organization}
                options={organizationList?.data
                  ?.filter(
                    (c) => c.sakhtar_dastgah_tabee_type === structureType,
                  )
                  .filter((c) => c.department === department)
                  ?.map((c) => ({
                    label: c.title,
                    value: c.id,
                  }))}
                onChange={(e) => {
                  setOrganization(e.value);
                  removeError("organization");
                }}
              />
              {errors["organization"] && (
                <p className={"text-sm mt-2 text-red-600"}>
                  {errors["organization"]}
                </p>
              )}
            </div>
            <div className="form-field w-full relative mt-2">
              <Input
                label={"معاونت/مدیریت/ مدرسه و ..."}
                onChange={(c) => setAssistance(c)}
                value={assistance}
              />
            </div>
            <div className="form-field w-full relative mt-2">
              <Input
                label={"نام و نام خانوادگی"}
                onChange={(c) => setFullName(c)}
                value={fullName}
              />
            </div>
            <div className="form-field w-full relative mt-2">
              <Input
                label={"شماره تماس"}
                value={landlineNumber}
                onChange={(c) => {
                  removeError("landlineNumber");
                  setLandlineNumber(c.startsWith("0") ? c : `0${c}`);
                }}
                placeholder={"شماره ثابت به همراه کد شهر"}
              />
              {errors["landlineNumber"] && (
                <p className={"text-sm mt-2 text-red-600"}>
                  {errors["landlineNumber"]}
                </p>
              )}
            </div>
            <div className="form-field w-full relative mt-2">
              <Input
                disabled={true}
                readOnly
                label={"شماره همراه"}
                onChange={(c) => setLandlineNumber(c)}
                value={phoneNumber}
              />
            </div>
          </div>
          <div className="flex justify-center w-full mt-8">
            <button
              onClick={submitForm}
              className=" bg-blue-500 text-white w-[102px] py-3 rounded-lg flex items-center justify-center"
            >
              ویرایش
              <Loading isLoading={updateProfileLoading || profileLoading} />
            </button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ProfilePage;
